import NavigationSuggestionsSection from './NavigationSuggestions';
import IncrementalSearchSection from './IncrementalSearch';
import QuerySuggestionsSection from './QuerySuggestions';
import RecentSearchesSection from './RecentSearches';
import RecentInteractionsSection from './RecentInteractions';
export default {
    NAVIGATION_SUGGESTIONS: NavigationSuggestionsSection,
    INCREMENTAL_SEARCH: IncrementalSearchSection,
    QUERY_SUGGESTIONS: QuerySuggestionsSection,
    RECENT_SEARCHES: RecentSearchesSection,
    RECENT_ITERACTIONS: RecentInteractionsSection,
};
//# sourceMappingURL=index.js.map